import { Map } from 'immutable';
import { getPlatform } from '@iso/lib/helpers/mobileAppCommKit';

export function clearToken() {
  localStorage.removeItem('idToken');
}

export function clearKeyGen() {
  localStorage.removeItem('ASTERISM0000');
}

export function clearPassport() {
  localStorage.removeItem('ASTERISM0001');
}

export function clearModules() {
  localStorage.removeItem('modules');
}

export function clearIdentity() {
  localStorage.removeItem('identity');
}

export function clearStores() {
  localStorage.removeItem('stores');
}
export function clearTopic() {
  localStorage.removeItem('topic');
}
export function clearEnv() {
  localStorage.removeItem('env');
}
export function clearMqttToken() {
  localStorage.removeItem('mqttToken');
}
export function clearCustomAuth() {
  localStorage.removeItem('customAuthorizations');
}
export function clearCustomModule() {
  localStorage.removeItem('customModules');
}
export function clearRoles() {
  localStorage.removeItem('roles');
}
export function clearForbidToken() {
  localStorage.removeItem('forbidToken');
}
export function clearMerchantList() {
  localStorage.removeItem('merchantList');
}
export function clearSelectedMerchant() {
  localStorage.removeItem('selectedMerchant');
}
export function clearSelectedMerchantName() {
  localStorage.removeItem('selectedMerchantName');
}
export function clearCountry() {
  localStorage.removeItem('country');
}
export function clearKYCProviders() {
  localStorage.removeItem('kycProviders');
}

export function getToken() {
  try {
    const idToken = localStorage.getItem('idToken');
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function getKeyGen() {
  try {
    const keyGen = localStorage.getItem('ASTERISM0000');
    return new Map({ keyGen });
  } catch (err) {
    clearKeyGen();
    return new Map();
  }
}

export function getPassport() {
  try {
    const passport = localStorage.getItem('ASTERISM0001');
    return new Map({ passport });
  } catch (err) {
    clearPassport();
    return new Map();
  }
}

export function getModules() {
  try {
    const modules = localStorage.getItem('modules');
    return new Map({ modules });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getForbidToken() {
  try {
    const forbidToken = localStorage.getItem('forbidToken');
    return new Map({ forbidToken });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getIdentity() {
  try {
    const identity = localStorage.getItem('identity');
    return new Map({ identity });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getStores() {
  try {
    const stores = localStorage.getItem('stores');
    return new Map({ stores });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getTopic() {
  try {
    const topic = localStorage.getItem('topic');
    return new Map({ topic });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getEnv() {
  try {
    const env = localStorage.getItem('env');
    return new Map({ env });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getMqttToken() {
  try {
    const mqttToken = localStorage.getItem('mqttToken');
    return new Map({ mqttToken });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getCustomAuth() {
  try {
    const customAuthorizations = localStorage.getItem('customAuthorizations');
    return new Map({ customAuthorizations });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getCustomModule() {
  try {
    const customModules = localStorage.getItem('customModules');
    return new Map({ customModules });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getRoles() {
  try {
    const roles = localStorage.getItem('roles');
    return new Map({ roles });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getMerchantList() {
  try {
    const merchantList = localStorage.getItem('merchantList');
    return new Map({ merchantList });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getSelectedMerchant() {
  try {
    const selectedMerchant = localStorage.getItem('selectedMerchant');
    return new Map({ selectedMerchant });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getSelectedMerchantName() {
  try {
    const selectedMerchantName = localStorage.getItem('selectedMerchantName');
    return new Map({ selectedMerchantName });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getCountry() {
  try {
    const country = localStorage.getItem('country');
    return new Map({ country });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getKYCProviders() {
  try {
    const kycProviders = localStorage.getItem('kycProviders');
    return new Map({ kycProviders });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToDouble(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseFloat(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function customLogs(text, object) {
  if (process.env.REACT_APP_ENV_INDICATOR === 'DEV') {
    if (object && object !== undefined) {
      return console.log(text, object)
    } else {
      return console.log(text)
    }
  } else {
    return null
  }
}

export function getRequestFormats() {
  try {
    const requestFormats = localStorage.getItem('requestFormats');
    return new Map({ requestFormats });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getResetData() {
  try {
    const resetData = localStorage.getItem('resetData');
    return new Map({ resetData });
  } catch (err) {
    clearResetData();
    return new Map();
  }
}

export function clearRequestFormats() {
  localStorage.removeItem('requestFormats');
}

export function clearResetData() {
  localStorage.removeItem('resetData');
}

export function injectRequestorInformation(data) {
  const platform = getPlatform()

  return {
    ...data,
    requestor_information: {
      device_information:  platform.agent.device,
      browser_information: platform.agent.browser,
      os_information: platform.agent.os
    }
  }
}